import { LocalizedValueDto } from "gql/graphql";

export function extractLocalizedValue(
  value: LocalizedValueDto | null | undefined,
) {
  return {
    langValueEn: value?.langValueEn,
    langValueKz: value?.langValueKz,
    langValueRu: value?.langValueRu,
    langValueUz: value?.langValueUz,
  };
}
